/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Публичные настройки визуала для нативных форм FxId (оплата, сбор PI и т.д.)
 * Передаются на фронтенд для кастомизации внешнего вида форм
 * @export
 * @interface FxIdDomainSettingsFxNativeStyleOptions
 */
export interface FxIdDomainSettingsFxNativeStyleOptions {
    /**
     * URL логотипа игры 
     * @type {string}
     * @memberof FxIdDomainSettingsFxNativeStyleOptions
     */
    LogoUrl?: string | null;
    /**
     * URL фонового изображения
     * @type {string}
     * @memberof FxIdDomainSettingsFxNativeStyleOptions
     */
    BackgroundImageUrl?: string | null;
    /**
     * URL текстурного оверлея для фона
     * @type {string}
     * @memberof FxIdDomainSettingsFxNativeStyleOptions
     */
    TextureOverlayUrl?: string | null;
    /**
     * Начальный цвет градиента фона для элементов списка способов оплаты (по умолчанию: rgba(245, 245, 245, 1))
     * @type {string}
     * @memberof FxIdDomainSettingsFxNativeStyleOptions
     */
    PaymentItemGradientStartColor?: string | null;
    /**
     * Конечный цвет градиента фона для элементов списка способов оплаты (по умолчанию: rgba(245, 245, 245, 0.2))
     * @type {string}
     * @memberof FxIdDomainSettingsFxNativeStyleOptions
     */
    PaymentItemGradientEndColor?: string | null;
    /**
     * Цвет темного оверлея для градиентов фона (по умолчанию: rgba(0, 0, 0, 0.4))
     * @type {string}
     * @memberof FxIdDomainSettingsFxNativeStyleOptions
     */
    OverlayColor?: string | null;
    /**
     * Цвет градиента для блока с товаром (по умолчанию: #3A3A3B)
     * @type {string}
     * @memberof FxIdDomainSettingsFxNativeStyleOptions
     */
    ProductOfferGradientColor?: string | null;
    /**
     * Цвет текста (по умолчанию: #313131)
     * @type {string}
     * @memberof FxIdDomainSettingsFxNativeStyleOptions
     */
    TextColor?: string | null;
}

/**
 * Check if a given object implements the FxIdDomainSettingsFxNativeStyleOptions interface.
 */
export function instanceOfFxIdDomainSettingsFxNativeStyleOptions(value: object): value is FxIdDomainSettingsFxNativeStyleOptions {
    return true;
}

export function FxIdDomainSettingsFxNativeStyleOptionsFromJSON(json: any): FxIdDomainSettingsFxNativeStyleOptions {
    return FxIdDomainSettingsFxNativeStyleOptionsFromJSONTyped(json, false);
}

export function FxIdDomainSettingsFxNativeStyleOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsFxNativeStyleOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'LogoUrl': json['LogoUrl'] == null ? undefined : json['LogoUrl'],
        'BackgroundImageUrl': json['BackgroundImageUrl'] == null ? undefined : json['BackgroundImageUrl'],
        'TextureOverlayUrl': json['TextureOverlayUrl'] == null ? undefined : json['TextureOverlayUrl'],
        'PaymentItemGradientStartColor': json['PaymentItemGradientStartColor'] == null ? undefined : json['PaymentItemGradientStartColor'],
        'PaymentItemGradientEndColor': json['PaymentItemGradientEndColor'] == null ? undefined : json['PaymentItemGradientEndColor'],
        'OverlayColor': json['OverlayColor'] == null ? undefined : json['OverlayColor'],
        'ProductOfferGradientColor': json['ProductOfferGradientColor'] == null ? undefined : json['ProductOfferGradientColor'],
        'TextColor': json['TextColor'] == null ? undefined : json['TextColor'],
    };
}

export function FxIdDomainSettingsFxNativeStyleOptionsToJSON(json: any): FxIdDomainSettingsFxNativeStyleOptions {
    return FxIdDomainSettingsFxNativeStyleOptionsToJSONTyped(json, false);
}

export function FxIdDomainSettingsFxNativeStyleOptionsToJSONTyped(value?: FxIdDomainSettingsFxNativeStyleOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'LogoUrl': value['LogoUrl'],
        'BackgroundImageUrl': value['BackgroundImageUrl'],
        'TextureOverlayUrl': value['TextureOverlayUrl'],
        'PaymentItemGradientStartColor': value['PaymentItemGradientStartColor'],
        'PaymentItemGradientEndColor': value['PaymentItemGradientEndColor'],
        'OverlayColor': value['OverlayColor'],
        'ProductOfferGradientColor': value['ProductOfferGradientColor'],
        'TextColor': value['TextColor'],
    };
}

